import Vue from 'vue';
import axios from 'axios';
import Qs from 'qs';
import { getDeviceName, getSystemName } from '@/utils/device';

import store from '@/store';
import api from './interface';
import i18n from '@/assets/js/i18n';
import VueAxios from 'vue-axios';
import NativeApp from '@/utils/app';
import { COMEIN_URL } from './host';
import { getUserInfo, isWxMiniProgram, decrypt, getCookie } from '@/utils/api';
import { decryptRequest } from '@/utils/decryptRequest';
import { REQUEST_VERSION, REQUEST_SALT, isApp } from '@/utils/const';
import { txCaptcha } from '@/utils/captcha';

Vue.use(VueAxios, axios);
const vue = new Vue();

axios.defaults.timeout = 30000;
axios.defaults.retry = 4;
axios.defaults.retryDelay = 1000;
axios.defaults.retryCount = 0;
axios.defaults.headers = {
	'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
};

// 请求拦截
axios.interceptors.request.use(
	function (config) {
		config?.headers?.showLoading !== false && store.dispatch('showLoading');
		return config;
	},
	function (error) {
		store.dispatch('hideLoading');
		return Promise.reject(error);
	}
);

// 响应拦截
axios.interceptors.response.use(resInterceptor, resRetryInterceptor);

function resInterceptor(res) {
	decryptRes(res);

	const code = ~~res.data.errorcode || ~~res.data.code;
	// 电子签的状态码不是0
	const isESign = res.request.responseURL.includes('esign');
	if (isESign) {
		store.dispatch('hideLoading');
		return res.data;
	}
	store.dispatch('hideLoading');
	return code ? errorResponse(res) : res.data;
}

function decryptRes(res) {
	let resHeaders = res.request.getAllResponseHeaders();
	let headers = resHeaders.trim().split(/[\r\n]+/);
	let header = headers.reduce((obj, line) => {
		let [key, value] = line.split(':');
		obj[key.trim()] = value.trim();
		return obj;
	}, {});
	if (header.k) {
		res.data = JSON.parse(decryptRequest(header.k, res.data, REQUEST_SALT));
	}
}

function errorResponse(err) {
	// 默认请求超时
	let response = {
		code: 500,
		msg: '网络较差，请稍后重试'
	};

	// http status 状态码500
	if (err.response && err.response.status == 500) {
		response = {
			code: 500,
			msg: '连接服务器失败，请稍后重试'
		};
	}

	// 对返回值赋值
	Object.assign(response, err?.data || err?.response?.data);

	// 处理errorcode 和 code
	response.code = response.errorcode || response.code;
	response.msg = response.errordesc || response.msg;

	const code = ~~response.code;

	if (!err.config.hideError) {
		switch (code) {
			case 201:
				store.commit('dispatchEvent', {
					eventName: 'loginOut'
				});
				store.dispatch('handleError201');
				break;
			case 212:
				return invokeCaptcha(err);
			default:
				if (err.config.hasOwnProperty('hideMessage') && !err.config.hideMessage) {
					store.dispatch('showTooltip', response.msg);
				}
		}
	}

	return handleReject(err, response);
}

// 兼容fetch的调用
function handleReject(err, response) {
	return err.config.hasOwnProperty('hideMessage') ? Promise.reject(response) : Promise.resolve(response);
}

async function invokeCaptcha(err) {
	if ($axios.bolCaptcha) {
		try {
			await new Promise((resolve, reject) => {
				$axios.requestQueue.push({ resolve, reject });
			});
		} catch (e) {
			err.data.msg = err.data.errordesc = '安全验证失败，接口请求错误';

			return handleReject(err, err.data);
		}
	} else {
		$axios.bolCaptcha = true;

		try {
			if (isApp) {
				await NativeApp.getCaptDialogResult(err.data.data);
			} else if (isWxMiniProgram) {
				$axios.bolCaptcha = false;
				$axios.requestQueue = [];

				return wx.miniProgram.navigateTo({
					url: '/pages/login/captcha?uuid=' + (err.data.data && err.data.data.uuid ? err.data.data.uuid : '')
				});
			} else {
				// 获取行为验证码票据
				let res = await $axios.get('/waf/captcha');

				// 调用腾讯行为验证码
				let txRes = await txCaptcha({
					appid: decrypt(res.data.captchaAppId, 'FB1798D4015EE8ED')
				});

				// 完成验证解除异常
				await $axios.get('/waf/toAllowList', {
					ticket: txRes.ticket,
					randStr: txRes.randstr,
					...err.data.data
				});
			}

			$axios.bolCaptcha = false;

			$axios.requestQueue.forEach(({ resolve }) => resolve());
			$axios.requestQueue = [];
		} catch (e) {
			$axios.bolCaptcha = false;

			$axios.requestQueue.forEach(({ reject }) => reject());
			$axios.requestQueue = [];

			err.data.msg = err.data.errordesc = '安全验证失败，接口请求错误';

			store.dispatch('showTooltip', '活体验证失败，接口请求错误');

			return handleReject(err, err.data);
		}
	}

	return axios.request(err.config);
}

async function resRetryInterceptor(err) {
	console.log('🚀 ~ resRetryInterceptor ~ err:', err.config);
	const config = err.config;

	// If config does not exist or the retry option is not set, reject
	if (!config || !config.retry) {
		store.dispatch('hideLoading');
		return errorResponse(err);
	}

	// Check if we've maxed out the total number of retries
	if (config.retryCount >= config.retry) {
		// Reject with the error
		// axios.interceptors.response.eject(resInterceptors);
		store.dispatch('hideLoading');
		// const msg = err?.response?.data?.msg || '网络较差，请稍后重试';
		// if (err.config.hasOwnProperty('hideMessage') && !err.config.hideMessage) {
		// 	store.dispatch('showTooltip', msg);
		// }
		return errorResponse(err);
	}

	// Increase the retry count
	config.retryCount += 1;
	// Create new promise to handle exponential backoff
	const backoff = new Promise(function (resolve) {
		setTimeout(function () {
			resolve();
		}, config.retryDelay || 1);
	});

	// Return the promise in which recalls axios to retry the request
	await backoff;
	console.log(909090, config);
	return await axios.request(config);
}

class Axios {
	constructor() {
		// 是否弹出行为验证码进行验证
		this.bolCaptcha = false;

		// 等待请求队列
		this.requestQueue = [];
	}

	post(url = '', body = {}, options = {}) {
		//初始化请求配置参数
		let axiosConfig = new AxiosConfig(url, body, options);
		axiosConfig.method = 'post';
		axiosConfig.instance();

		switch (axiosConfig.bodyType) {
			case 'form':
				axiosConfig.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';

				axiosConfig.transformRequest = [
					data => {
						return typeof data === 'string' ? data : Qs.stringify(data);
					}
				];

				// 固定请求参数放在 body
				Object.assign(axiosConfig.data, axiosConfig.initUrl());
				break;
			case 'image':
			case 'file':
				axiosConfig.headers['Content-Type'] = 'multipart/form-data';
				axiosConfig.timeout = 1800000; //超时时间为半小时

				var formData = new FormData();
				Object.keys(body).map(index => {
					formData.append(index, body[index]);
				});
				axiosConfig.data = formData;
				break;
			default:
				// 默认json格式请求
				axiosConfig.headers['Content-Type'] = 'application/json;charset=utf-8';

				// 固定请求参数放在 headers
				Object.assign(axiosConfig.headers, axiosConfig.initUrl());
		}
		return axios.request(axiosConfig);
	}

	get(url = '', body = {}, options = {}) {
		let axiosConfig = new AxiosConfig(url, body, options);
		axiosConfig.method = 'get';
		axiosConfig.instance();

		axiosConfig.params = Object.assign({}, axiosConfig.data, axiosConfig.initUrl());

		return axios.request(axiosConfig);
	}
}

class AxiosConfig {
	constructor(url = '', body = {}, options = {}) {
		// 发送请求的地址
		this.url = url;

		// 发送请求的数据
		this.data = body;

		// 被发送的自定义请求头
		this.headers = {};

		// 与请求一起发送的 URL 参数
		this.params = {};

		// 自定义的一些参数
		// bodyType: String     请求参数数据类型 支持 json / form / file / image 默认json
		// hideMessage: Boolean 请求失败是否显示错误信息
		// timeout              请求超时时间
		// retry: Number        请求失败重试次数
		// retryDelay: Number   请求失败重试延迟时间
		// retryCount: Number   请求失败已经重试次数

		// 默认的错误
		this.hideError = false;
		// 错误信息
		this.hideMessage = false;

		Object.assign(this, options);
	}

	instance() {
		//默认设置token到请求头
		let userInfo = getUserInfo();

		// 免登录标识
		const isSkipAuth = this.headers.skipAuth || false;

		if (!isSkipAuth) {
			// 用户ID (非必填)
			const uid = this.headers?.uid || userInfo?.uid || '';
			this.headers.uid = uid;

			// 会话令牌 (非必填)
			const token = this.headers.token || this.headers.webtoken || userInfo?.token || userInfo?.webtoken || '';
			this.headers.token = this.headers.webtoken = token;
		} else {
			// 支持临时 token 访问
			const temporaryToken = this.headers.temporaryToken || '';
			if (temporaryToken) delete this.headers.temporaryToken;
			this.headers.token = this.headers.webtoken = temporaryToken;
		}

		// 操作系统平台 ios android web
		this.headers.os = this.headers.os || 'web';
		// os为web的扩展字段 pc端传值：pc , 手机端传值：mobile
		this.headers.c = isWxMiniProgram ? 'applet' : 'h5';
		// os为web的扩展字段 web所处的环境 weixin qq comein minprogram
		this.headers.webenv = 'comein';
		// 手机操作系统
		this.headers.s = '';
		// 浏览器
		this.headers.browse = window.navigator.appName;
		// user agent
		this.headers.ua = window.navigator.userAgent;
		// 外部展 示版本号(3.0.3)
		this.headers.b = REQUEST_VERSION;
		// 用户渠道 comein-app, comein-pc, comein-h5 , comein-miniprogram , comein-assist (非必填)
		this.headers.uc = vue.$bridge.uc || 'irm-mobile'; // "comein-pc";
		// 系统名称
		this.headers.sn = getSystemName();
		// 设备名称
		this.headers.dn = getDeviceName();
		// 语言language
		this.headers.language = i18n.locale;
		// release 预发布环境参数
		this.headers.release = getCookie('release') || null;
		// symbol
		this.headers.symbol = getCookie('symbol') || null;
		/** 上述参数中非必选的参数，在能拿到信息的情况下都需要传入接口。 */
	}

	initUrl() {
		let arr = this.url.split('_');

		if (arr.length === 3) {
			this.url = api.common.phpUrl;
			const [app, mod, act] = arr;
			return {
				app,
				mod,
				act
			};
		}

		if (!/^https?/.test(this.url)) {
			this.url = COMEIN_URL + this.url;
		}
		return {};
	}
}

const $axios = new Axios();

Vue.prototype.$axios = $axios;

export default $axios;
